import { useApp } from "@/contexts/AppContext";

/**
 * Returns the correct Bud Link seal + label for the user's current
 * location state. Falls back to the Pennsylvania mark when we don't yet
 * know the state (first visit, no ZIP entered, GPS blocked, etc).
 *
 * Add a new state = drop a `budlink-logo-<code>.png` into `/public` and
 * add a row here. Everything downstream (header, footer, age-gate)
 * picks it up automatically.
 */
const STATE_LOGOS = {
  PA: { src: "/budlink-logo.png",     label: "Bud Link Pennsylvania" },
  CO: { src: "/budlink-logo-co.png",  label: "Bud Link Colorado"    },
  OR: { src: "/budlink-logo-or.png",  label: "Bud Link Oregon"      },
};

export function useBrandLogo() {
  const { location } = useApp() || {};
  const state = (location?.state || "").toUpperCase();
  return STATE_LOGOS[state] || STATE_LOGOS.PA;
}

export default useBrandLogo;
